import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular//http';
import { User } from '../_models/index';
import 'rxjs/add/operator/toPromise';
import { AuthHttp } from 'angular2-jwt';
import { environment } from '../../environments/environment';

@Injectable()

export class PurchasePointsSettingsServices {

    backendUrl: any;
    TOKEN: any;
    headers: any;
    options: any;
    secret: any;

    api = "/purchasepointssettings/"

    constructor(private http: AuthHttp) {
        // this.backendUrl = environment.url;
        this.backendUrl=window.location.origin
        this.backendUrl+="/apis"
        this.secret = environment.secret;
    }

     getallPurchasePointsConfiguration(id:any) {
        return this.http.get(`${this.backendUrl}${this.api}all-purchase-points-data/${id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    updatePurchasePointsConfigurationById(data) {
        return this.http.post(`${this.backendUrl}${this.api}update-purchase-points-id/` ,data, this.jwt_new()).map((response: Response) => response.json());
    }

    deletePurchasePointsConfigurationById(data) {
        return this.http.post(`${this.backendUrl}${this.api}delete-purchase-points-id/` ,data, this.jwt_new()).map((response: Response) => response.json());
    }

    ModifyPurchasePointsDataById(id:any) {
        return this.http.get(`${this.backendUrl}${this.api}modify-purchase-points-data/${id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    AddUpdatePurchasePointsConfiguration(data) {
        return this.http.post(`${this.backendUrl}${this.api}add-update-purchase-points/` ,data, this.jwt_new()).map((response: Response) => response.json());
    }

    getRedemptionRuleDataByRestId(id:any) {
        return this.http.get(`${this.backendUrl}${this.api}get-redemption-rule-count/${id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    private jwt_new() {
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.headers.append('Authorization', this.TOKEN)
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    private jwt() {
        // create authorization header with jwt token
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        let headers = new Headers({ 'Authorization': this.TOKEN });
        return new RequestOptions({ headers: headers });
    }
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_services/purchasepointssettings.service.ts